import { z } from 'zod';
import { 
  LandingCardActionTypeEnum,
  landingCardActionDataSchema, 
  landingCardOverrideDataSchema,
  agentResponseJsonDataSchema
} from '../enums/landing-cards.js';

export const chatContextSchema = z.object({
  id: z.number(),
  name: z.string(),
  identifier: z.string().optional(),
});

const baseLandingCardSchema = z.object({
  id: z.coerce.number(),
  title: z.string().nullable(),
  description: z.string().nullable(),
  icon: z.string().nullable(),
  chatContext: chatContextSchema.nullable(),
  overrideData: landingCardOverrideDataSchema,
  isHidden: z.boolean(),
  order: z.coerce.number().nullable(),
});

export const landingCardRecordSchema = z.discriminatedUnion('actionType', [
  baseLandingCardSchema.extend({
    actionType: z.literal(LandingCardActionTypeEnum.Dispatch),
    actionData: z.object({}).nullable(),
  }),
  baseLandingCardSchema.extend({
    actionType: z.literal(LandingCardActionTypeEnum.PromptInjection),
    actionData: z.object({ prompt: z.string() }),
  }),
  baseLandingCardSchema.extend({
    actionType: z.literal(LandingCardActionTypeEnum.Custom),
    actionData: z.object({ function: z.string() }),
  }),
  baseLandingCardSchema.extend({
    actionType: z.literal(LandingCardActionTypeEnum.Redirect),
    actionData: z.object({ url: z.string() }),
  }),
  baseLandingCardSchema.extend({
    actionType: z.literal(LandingCardActionTypeEnum.PassResponseDirectlyToAgent),
    actionData: agentResponseJsonDataSchema,
  }),
]);

export type LandingCardRecord = z.infer<typeof landingCardRecordSchema>;
